export default __webpack_public_path__ + "static/media/Port.b04cca72.svg";